import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer';
import Home from './pages/Home';
import Services from './pages/Services';
import About from './pages/About';
import Contact from './pages/Contact';
import Gallery from './pages/Gallery';
import OctobreRose from './pages/OctobreRose';
import SocialFollow from './components/SocialFollow';
import './App.css';

function App() {
  useEffect(() => {
    // Global error handler for script errors
    const handleError = (event: ErrorEvent) => {
      console.error('Global error caught:', event.error);
      // Prevent default browser error handling
      event.preventDefault();
    };

    // Handle unhandled promise rejections
    const handleUnhandledRejection = (event: PromiseRejectionEvent) => {
      console.error('Unhandled promise rejection:', event.reason);
      event.preventDefault();
    };

    window.addEventListener('error', handleError);
    window.addEventListener('unhandledrejection', handleUnhandledRejection);

    return () => {
      window.removeEventListener('error', handleError);
      window.removeEventListener('unhandledrejection', handleUnhandledRejection);
    };
  }, []);

  return (
    <Router>
      <div className="min-h-screen bg-gray-50">
        <Header />
        <main>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/services" element={<Services />} />
            <Route path="/about" element={<About />} />
            <Route path="/gallery" element={<Gallery />} />
            <Route path="/octobre-rose" element={<OctobreRose />} />
            <Route path="/contact" element={<Contact />} />
          </Routes>
        </main>
        <SocialFollow />
        <Footer />
      </div>
    </Router>
  );
}

export default App;